function openTab(evt, cityName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" activeItem", "");
  }
  document.getElementById(cityName).style.display = "block";
  evt.currentTarget.className += " activeItem";
}
if(document.getElementById("defaultOpen")) {
  document.getElementById("defaultOpen").click();
}
window.onload = function () {
  $(".lp-customer-review__wrapper .tabcontent .review-title").click(function (
    e
  ) {
    const $title = $(this);
    const $review = $(this).parent();
    if ($title.hasClass("open")) {
      $review.find(".review-content").slideUp();
      $title.toggleClass("open", false);
    } else {
      $review.parent().find(".review-content").slideUp();
      $review.parent().find(".review-title").toggleClass("open", false);
      $review.find(".review-content").slideDown();
      $title.toggleClass("open", true);
    }
  });

  $("#section-lp-hybrid-specification .characteristic-title").click(function (
    e
  ) {
    const $title = $(this);
    const $characteristic = $(this).parent();
    if ($title.hasClass("open")) {
      $characteristic.find(".characteristic-content").slideUp();
      $title.toggleClass("open", false);
    } else {
      $characteristic.parent().find(".characteristic-content").slideUp();
      $characteristic
        .parent()
        .find(".characteristic-title")
        .toggleClass("open", false);
      $characteristic.find(".characteristic-content").slideDown();
      $title.toggleClass("open", true);
    }
  });

  $("#section-lp-mattress-specification .characteristics-title").click(
    function (e) {
      const $title = $(this);
      const $characteristic = $(this).parent();
      if ($title.hasClass("open")) {
        $characteristic.find(".characteristics-content").slideUp();
        $title.toggleClass("open", false);
      } else {
        $characteristic.parent().find(".characteristics-content").slideUp();
        $characteristic
          .parent()
          .find(".characteristics-title")
          .toggleClass("open", false);
        $characteristic.find(".characteristics-content").slideDown();
        $title.toggleClass("open", true);
      }
    }
  );
};
